import { render } from "./ModalSwiper.vue?vue&type=template&id=d780b694"
import script from "./ModalSwiper.vue?vue&type=script&lang=js"
export * from "./ModalSwiper.vue?vue&type=script&lang=js"

import "./ModalSwiper.vue?vue&type=style&index=0&id=d780b694&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__